module.exports = __webpack_public_path__ + "img/map_line.3217623d.svg";